import { ContentRecommendedListModel } from '@/domain/models/content/user-content-recommended-model'
import { ContentRecommendationType } from '@/domain/models/content/content-recommendation-type'

export interface UserContentRecommended {
  get(
    type: ContentRecommendationType.Enum,
    limit: number,
    correlationId?: number
  ): Promise<UserContentRecommended.Model>
}

export namespace UserContentRecommended {
  export type Model = ContentRecommendedListModel
  export const Key = 'user-content-recommended'
}
